<span class="k-window-title">{{ title() }}</span>
@if (state() === 'maximized') {
} @else if (state() !== 'minimized') {
    <button
        type="button"
        class="k-window-titlebar-action k-button k-button-md k-rounded-md k-button-flat k-button-flat-base"
        (click)="toggleMinimize()"
    >
        <kendo-svg-icon [icon]="windowMinimizeIcon"></kendo-svg-icon>
    </button>
}
@if (state() === 'minimized') {
    <button
        type="button"
        class="k-window-titlebar-action k-button k-button-md k-rounded-md k-button-flat k-button-flat-base"
        (click)="state.set('default')"
    >
        <kendo-svg-icon [icon]="windowRestoreIcon"></kendo-svg-icon>
    </button>
} @else if (state() === 'maximized') {
    <button
        type="button"
        class="k-window-titlebar-action k-button k-button-md k-rounded-md k-button-flat k-button-flat-base"
        (click)="state.set('default')"
    >
        <kendo-svg-icon [icon]="windowRestoreIcon"></kendo-svg-icon>
    </button>
} @else {
    <button
        type="button"
        class="k-window-titlebar-action k-button k-button-md k-rounded-md k-button-flat k-button-flat-base"
        (click)="state.set('maximized')"
    >
        <kendo-svg-icon [icon]="windowIcon"></kendo-svg-icon>
    </button>
}

<button
    type="button"
    class="k-window-titlebar-action k-button k-button-md k-rounded-md k-button-flat k-button-flat-base"
    (click)="onClose()"
>
    <kendo-svg-icon [icon]="xIcon"></kendo-svg-icon>
</button>
